export const formatPathWithTrailingSlash = (path: string) => {
  if (path.length === 0) {
    return '';
  }

  return path.endsWith('/') ? path : path + '/';
};
